/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: fitness-service/v1/auth.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.SignupRequest,
 *   !proto.fitness.service.v1.AuthResponse>}
 */
const methodDescriptor_AuthService_Signup = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/Signup',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.SignupRequest,
  proto.fitness.service.v1.AuthResponse,
  /**
   * @param {!proto.fitness.service.v1.SignupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AuthResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.SignupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.signup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/Signup',
      request,
      metadata || {},
      methodDescriptor_AuthService_Signup,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.SignupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AuthResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.signup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/Signup',
      request,
      metadata || {},
      methodDescriptor_AuthService_Signup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.LoginRequest,
 *   !proto.fitness.service.v1.AuthResponse>}
 */
const methodDescriptor_AuthService_Login = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/Login',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.LoginRequest,
  proto.fitness.service.v1.AuthResponse,
  /**
   * @param {!proto.fitness.service.v1.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AuthResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AuthResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.RefreshTokenRequest,
 *   !proto.fitness.service.v1.AuthResponse>}
 */
const methodDescriptor_AuthService_RefreshToken = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/RefreshToken',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.RefreshTokenRequest,
  proto.fitness.service.v1.AuthResponse,
  /**
   * @param {!proto.fitness.service.v1.RefreshTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AuthResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.refreshToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_AuthService_RefreshToken,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AuthResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.refreshToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_AuthService_RefreshToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.LogoutRequest,
 *   !proto.fitness.service.v1.LogoutResponse>}
 */
const methodDescriptor_AuthService_Logout = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/Logout',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.LogoutRequest,
  proto.fitness.service.v1.LogoutResponse,
  /**
   * @param {!proto.fitness.service.v1.LogoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.LogoutResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.LogoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.LogoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/Logout',
      request,
      metadata || {},
      methodDescriptor_AuthService_Logout,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.LogoutResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/Logout',
      request,
      metadata || {},
      methodDescriptor_AuthService_Logout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.ChangePasswordRequest,
 *   !proto.fitness.service.v1.ChangePasswordResponse>}
 */
const methodDescriptor_AuthService_ChangePassword = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/ChangePassword',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.ChangePasswordRequest,
  proto.fitness.service.v1.ChangePasswordResponse,
  /**
   * @param {!proto.fitness.service.v1.ChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.ChangePasswordResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.ChangePasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.ChangePasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.changePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_AuthService_ChangePassword,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.ChangePasswordResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.changePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_AuthService_ChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.RequestPasswordResetRequest,
 *   !proto.fitness.service.v1.RequestPasswordResetResponse>}
 */
const methodDescriptor_AuthService_RequestPasswordReset = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/RequestPasswordReset',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.RequestPasswordResetRequest,
  proto.fitness.service.v1.RequestPasswordResetResponse,
  /**
   * @param {!proto.fitness.service.v1.RequestPasswordResetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.RequestPasswordResetResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.RequestPasswordResetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.RequestPasswordResetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.RequestPasswordResetResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.requestPasswordReset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/RequestPasswordReset',
      request,
      metadata || {},
      methodDescriptor_AuthService_RequestPasswordReset,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.RequestPasswordResetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.RequestPasswordResetResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.requestPasswordReset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/RequestPasswordReset',
      request,
      metadata || {},
      methodDescriptor_AuthService_RequestPasswordReset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.ResetPasswordRequest,
 *   !proto.fitness.service.v1.ResetPasswordResponse>}
 */
const methodDescriptor_AuthService_ResetPassword = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AuthService/ResetPassword',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.ResetPasswordRequest,
  proto.fitness.service.v1.ResetPasswordResponse,
  /**
   * @param {!proto.fitness.service.v1.ResetPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.ResetPasswordResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.ResetPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.ResetPasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.ResetPasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AuthServiceClient.prototype.resetPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AuthService/ResetPassword',
      request,
      metadata || {},
      methodDescriptor_AuthService_ResetPassword,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.ResetPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.ResetPasswordResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AuthServicePromiseClient.prototype.resetPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AuthService/ResetPassword',
      request,
      metadata || {},
      methodDescriptor_AuthService_ResetPassword);
};


module.exports = proto.fitness.service.v1;

